import {Box} from '@mui/material';
import AurVideoControls from './AurVideoControls';
import AurVideoProgress from './AurVideoProgress';
import {useVideoPlayer} from './useVideoPlayer';

interface AurVideoPlayerProps {
  src: string;
  poster?: string; //thumbnail
  className?: string;
}

const AurVideoPlayer = ({src, poster, className}: AurVideoPlayerProps) => {
  const {
    videoRef,
    isPlaying,
    currentTime,
    duration,
    buffered,
    togglePlay,
    seek,
  } = useVideoPlayer();

  return (
    <Box className={`video-container-container ${className}`}>
      <video
        ref={videoRef}
        src={src}
        poster={poster}
        controls={false}
        preload="metadata"
        disablePictureInPicture
        disableRemotePlayback
      />

      <AurVideoControls isPlaying={isPlaying} togglePlay={togglePlay}>
        <AurVideoProgress
          currentTime={currentTime}
          duration={duration}
          onSeek={seek}
          buffered={buffered}
        />
      </AurVideoControls>
    </Box>
  );
};

export default AurVideoPlayer;
